/**
 * @generated SignedSource<<4f4a834151a52f067367afeb5208013d>>
 * @relayHash 1f4edee79dfe6ac309bec2936269d48a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileImportCollectionRetryMutation

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionRetryMutation$variables = {
  nftItemIds?: ReadonlyArray<string> | null;
};
export type NftProfileImportCollectionRetryMutation$data = {
  readonly nftRetryItemImport: {
    readonly nftItems: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionRetry_nftItem">;
    } | null> | null;
  } | null;
};
export type NftProfileImportCollectionRetryMutation = {
  response: NftProfileImportCollectionRetryMutation$data;
  variables: NftProfileImportCollectionRetryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nftItemIds"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nftItemIds",
        "variableName": "nftItemIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionRetryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftRetryItemImportPayload",
        "kind": "LinkedField",
        "name": "nftRetryItemImport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftProfileImportCollectionRetry_nftItem"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftProfileImportCollectionRetryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftRetryItemImportPayload",
        "kind": "LinkedField",
        "name": "nftRetryItemImport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "importErrorReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileImportCollectionRetryMutation",
    "metadata": {},
    "name": "NftProfileImportCollectionRetryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7e01bcf4c3fcc10b0c3352bc14e454a3";

export default node;
